import { Component, Input, OnInit, signal } from '@angular/core';
import { BookingsService } from '../../../core/services/bookings.service';
import { Booking } from '../../../core/models/entities/booking';
import { firstValueFrom } from 'rxjs';
import { UnlockDoorService } from '../../../core/services/unlock-door.service';

@Component({
  template: `
    <div class="container">
      @if (loading()) {
        <app-loader
          [centered]="true"
        ></app-loader>
      } @else {
        @if (loadingError()) {
          <div>
            <app-empty-state
              [showAddButton]="false"
              icon="exclamation-triangle"
              [message]="'common.error.invalid-link' | transloco"
            ></app-empty-state>
          </div>
        } @else {
          <div class="flex h-screen flex-col items-center justify-center">
            <div class="relative text-center">
              <div class="text-xl font-bold">
                {{ booking.room.name }}
              </div>
              @if (booking.room.building?.name) {
                <div class="mt-2">
                  {{ booking.room.building.name }}
                </div>
              }
              <div class="mt-6">
                <app-button
                  [loading]="sendingData()"
                  variant="primary"
                  (click)="unlockDoor()"
                  >{{ 'common.unlock-door.button' | transloco }}
                </app-button>
              </div>
              @if (booking.room.emergency_phone_number; as emergencyNumber) {
                <div
                  class="mt-8 max-w-[400px]"
                  >
                  <app-alert
                    >{{ 'common.unlock-door.emergency' | transloco }}<br />
                    <a href="tel:{{ emergencyNumber }}">{{
                      emergencyNumber | phone
                    }}</a>
                  </app-alert>
                </div>
              }
            </div>
          </div>
        }
      }
    
    </div>
    `,
  standalone: false,
})
export class UnlockDoorPageComponent implements OnInit {
  @Input() token: string;
  loading = signal(false);
  sendingData = signal(false);
  doorUnlocked = signal(false);
  loadingError = signal(false);
  booking: Booking;

  constructor(
    private bookingsService: BookingsService,
    private unlockDoorService: UnlockDoorService,
  ) {}

  async ngOnInit() {
    this.loading.set(true);
    try {
      this.booking = (
        await firstValueFrom(this.bookingsService.findByToken(this.token))
      ).data;
    } catch (e) {
      console.error(e);
      this.loadingError.set(true);
    } finally {
      this.loading.set(false);
    }
  }

  async unlockDoor() {
    if (this.doorUnlocked()) {
      // UX: Prevent user from spamming the button
      this.sendingData.set(false);
      this.doorUnlocked.set(false);
    } else {
      this.sendingData.set(true);
      const success = await this.unlockDoorService.unlockDoor(this.token);
      if (success) {
        this.doorUnlocked.set(true);
        setTimeout(() => {
          this.doorUnlocked.set(false);
        }, 7500);
      }
      this.sendingData.set(false);
    }
  }
}
